const getMenuItemKey = (menuItems: any, currentURL: string) => {
  let value = {};
  menuItems?.forEach((mItem: { sub_menu_items: any[]; id: any }) => {
    mItem?.sub_menu_items?.forEach((sMItem) => {
      const isUrlExist = currentURL.startsWith(sMItem.url);
      if (currentURL === sMItem.url) {
        value = { open: true, id: mItem.id };
      } else if (isUrlExist) {
        value = { open: true, id: mItem.id };
      }
    });
  });
  return value;
};

export const getFavMenuItemKey = (
  menuItems: any,
  currentURL: string,
  type?: string
) => {
  let value = {};
  menuItems?.forEach((item: any) => {
    if (type === 'favorite' && currentURL === item?.submenu_item?.url) {
      value = { open: true, id: 'favorite-1' };
    }
  });

  return value;
};

export default getMenuItemKey;
